import { Button } from '@connected/ui/components/button';
import { AlertCircle } from 'lucide-react';

// TDOO: This is only an temporary component for handling project not found errors.
export function ProjectNotFound() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            <div className="max-w-md w-full text-center space-y-6">
                <div className="flex justify-center">
                    <div className="rounded-full bg-destructive/10 p-6">
                        <AlertCircle className="h-16 w-16 text-destructive" />
                    </div>
                </div>

                <div className="space-y-2">
                    <h1 className="text-3xl font-bold tracking-tight">
                        Project niet gevonden
                    </h1>
                    <p className="text-muted-foreground text-base">
                        Het opgevraagde project kan niet worden geladen. Dit kan betekenen dat het project niet bestaat of dat er een probleem is opgetreden.
                    </p>
                </div>

                <div className="pt-4 space-y-2 flex flex-col items-center">
                    <p className="text-sm text-muted-foreground">
                        Probeer het volgende:
                    </p>
                    <ul className="text-sm text-muted-foreground space-y-1 list-disc text-left">
                        <li>Controleer of de project-ID correct is</li>
                        <li>Ververs de pagina</li>
                        <li>Ga terug naar het projectenoverzicht</li>
                    </ul>
                    <Button variant="outline" onClick={() => window.history.back()}>
                        Ga terug
                    </Button>
                </div>
            </div>
        </div>
    );
}
